// extracted by mini-css-extract-plugin
export default {"Badge":"UserBadge_Badge__myiO3","SupporterBadge":"UserBadge_SupporterBadge__1s4GO","AdminBadge":"UserBadge_AdminBadge__3ARnW"};